export class FileModel {
    upload_urls: string[] = [];
    file_ids: number[] = [];
    max_files_upload = 100;
}

export interface FileModel {
    upload_urls: string[];
    file_ids: number[];
}
